
'use strict';

import $ from 'jquery';

import {scrollToElement} from './anchorScroll';
import {OjEvent} from './ojevent';



function setPriceHighlight (excl = false) {
    const orderOverview = document.querySelector('.order-overview');
    if ( !orderOverview ) return;

    const totalIncl = orderOverview.querySelector('.total');
    const totalExcl = orderOverview.querySelector('.total-excl');

    if ( excl === true ) {
        totalIncl.classList.remove('highlighted');
        totalExcl.classList.add('highlighted');
    } else {
        totalIncl.classList.add('highlighted');
        totalExcl.classList.remove('highlighted');
    }
}



function hasNoVatCountry () {
    const customDelivery = document.querySelector('#customer-delivery');
    const countryId = customDelivery.checked
                        ? document.querySelector('[name="deliveryCountry"]').value
                        : document.querySelector('[name="country"]').value;

    const noVatCountries = [ 12, 15, 26 ];

    return noVatCountries.indexOf(parseInt(countryId)) !== -1;
}



function isBusinessOrder () {
    const selectedInput = document.querySelector('.customer-form [name="type"]:checked');

    return selectedInput.value === 'business';
}



function checkPriceHighlight () {
    if ( hasNoVatCountry() ) {
        setPriceHighlight(true)
    } else if ( isBusinessOrder() ) {
        setPriceHighlight(true)
    } else {
        setPriceHighlight(false);
    }
}



function calculateCart () {
    if ( !document.querySelector('body.checkout .customer-form') ) return;

    checkPriceHighlight();

    const customDelivery = document.querySelector('#customer-delivery');
    const deliver = document.querySelector('[name="pickup"]:checked').value;
    const pickupPayment = document.querySelector('.payment-method[for="payment-shopPayment"]');

    if ( pickupPayment ) {
       if ( deliver == 1 ) {
           pickupPayment.classList.add('active');
       } else {
           pickupPayment.classList.remove('active');
           pickupPayment.querySelector('input').checked = false;
       }
    }


    const shippingType = deliver == 0
        ? 'Bezorgen'
        : 'Afhalen';

    fetch('/ajax/checkout/addShippingType?type='+ shippingType)
        .then(r => r.json())
        .then(response => {
            window.checkoutEventManager.addEvent(
                new OjEvent(
                    'add_shipping_info',
                    response,
                )
            );
        });

    window.store.product.calculateCart({
        pickup: deliver,
        customDelivery: customDelivery.checked,
        deliveryCountryId: customDelivery.checked ? document.querySelector('[name="deliveryCountry"]').value : null,
        countryId: document.querySelector('[name="country"]').value,
    });
};


function setupCalculateCart () {
    const changeInputs = document.querySelectorAll(`
        [name="type"],
        [name="pickup"],
        .customer-form [name="country"],
        .customer-form [name="deliveryCountry"],
        #customer-delivery`
    );

    if ( changeInputs ) {
        changeInputs
            .forEach(input => input.addEventListener('change', calculateCart));
    }
}



export default function setupCheckout () {
    setupCalculateCart();
    calculateCart();

    const paymentLabels = document.querySelectorAll('label.payment-method span');

    paymentLabels
        .forEach(label => label.addEventListener('click', evt => {
            evt.preventDefault();

            $('.payment-method-options-holder input[name="issuer"]').prop('checked', '');
            $('.payment-method-options-holder').slideUp();
            $('.payment-method-options-holder .error').remove();

            const input = label.parentElement.querySelector('input[type="radio"]');

            const nextElem = label.parentElement.nextElementSibling;
            if ( nextElem && nextElem.classList.contains('payment-method-options-holder') && !input.checked ) {
                $(nextElem).slideDown();
            }

            input.checked = !input.checked;


            const giftcardMessage = document.querySelector('.giftcard-message');
            if ( giftcardMessage ) {
                if ( input.checked && input.value === 'customgiftcard' ) {
                    giftcardMessage.classList.add('active');
                } else {
                    giftcardMessage.classList.remove('active');
                }
            }

            if ( input.checked ) {
                fetch('/ajax/checkout/addPaymentType?type='+ input.value)
                    .then(r => r.json())
                    .then(response => {
                        window.checkoutEventManager.addEvent(
                            new OjEvent(
                                'add_payment_info',
                                response,
                            )
                        );
                    });
            }
        })
    );

    // Scroll to comment input when payment option changes
    const commentField = document.querySelector('label[for="comment"]');
    if ( commentField ) {
        $('.payment-method-options [name="issuer"]').on('change', () => {
            scrollToElement(commentField);
        });
    }



    const giftCardNumber = document.querySelector('.payment-methods [name="cardnumber"]');

    if ( giftCardNumber ) {
        giftCardNumber.addEventListener('keydown', _ => {
            const regex = /.{1,4}/g;
            giftCardNumber.value = [...giftCardNumber.value.replaceAll('-', '').matchAll(regex)].join('-');
        });
    }
}
